import { MenuBulletHorizontal as MenuBulletHorizontal_kojaro } from './MenuBulletHorizontal.kojaro';
import { MenuBulletHorizontal as MenuBulletHorizontal_phosphor } from './MenuBulletHorizontal.phosphor';
import { MenuBulletHorizontal as MenuBulletHorizontal_zoomg } from './MenuBulletHorizontal.zoomg';
import { MenuBulletHorizontal as MenuBulletHorizontal_zoomit } from './MenuBulletHorizontal.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return MenuBulletHorizontal_kojaro;

    case 'zoomg':
      return MenuBulletHorizontal_zoomg;

    case 'phosphor':
      return MenuBulletHorizontal_phosphor;

    default:
      return MenuBulletHorizontal_zoomit;
  }
};

export const MenuBulletHorizontal = IconRenderer();
